<ui-section title="Lender Details">
	<div section-content class="space-y-6">
		<div class="mb-3">
			<app-checkbox
				label="Acting for Mortgagee"
				type="clear"
				[ngModel]="_matterMortgage?.actingForMortgagee"
				(ngModelChange)="setActingForMortgagee($event)"
			></app-checkbox>
		</div>
		<ui-info-row
			infoLabel="Lender"
			[infoValue]="_mortgage?.lender | lenderName"
		></ui-info-row>
		<ui-info-row
			infoLabel="Mortgagee"
			[infoValue]="_mortgage?.mortgagee | lenderName"
			*ngIf="_mortgage?.mortgagee?.lenderCode !== _mortgage?.lender?.lenderCode"
		></ui-info-row>
		<div
			class="mt-10"
			*ngIf="
				_mortgage?.data?.mortgageCentre?.firstName ||
				_mortgage?.data?.mortgageOwningBranch?.firstName
			"
		>
			<h4 class="mb-2">Contacts</h4>
			<div class="flex">
				<app-llc-contact-card
					class="flex mr-5"
					*ngIf="_mortgage?.data?.mortgageCentre?.firstName"
					type="branch"
					[contact]="_mortgage?.data?.mortgageCentre"
				></app-llc-contact-card>
				<app-llc-contact-card
					*ngIf="_mortgage?.data?.mortgageOwningBranch?.firstName"
					type="center"
					[contact]="_mortgage?.data?.mortgageOwningBranch"
				></app-llc-contact-card>
			</div>
		</div>
		<ui-info-row
			infoLabel="Servicing Branch Address"
			[infoValue]="serviceBranchAddress"
		></ui-info-row>
		<ui-info-row
			infoLabel="Servicing Branch Phone"
			[infoValue]="serviceBranch?.phone"
		></ui-info-row>
		<ui-info-row
			infoLabel="Mailing Address"
			[infoValue]="mailingBranchAddress"
		></ui-info-row>
		<ui-info-row
			infoLabel="Mailing Phone"
			[infoValue]="mailingBranch?.phone"
		></ui-info-row>
	</div>
</ui-section>
